/**
 * A portfolio whose orders the customer's Fortuna terminal sends (brokerMode CLIENT). Its bots
 * are started from the terminal, which reads the account first; the web may still stop them and
 * edit their settings. The BE refuses a web start with 409 either way.
 */
export const TERMINAL_START_MESSAGE =
  "This account's bots are started from the Fortuna terminal, which reads the account first. You can still stop them and edit their settings here.";

export const isTerminalAccount = (p?: { brokerMode?: string } | null): boolean => p?.brokerMode === 'CLIENT';
